export default __webpack_public_path__ + "static/0199-46e9c610ca1b5936d6781935ebb1c2aa.png";